import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { Toast } from 'primereact/toast';
import 'primereact/resources/themes/nova/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

class PaletSmartgrid extends Component {

    constructor(props) {
        super(props);

        this.state = { newRow: null, currentCriteria: null, currentKpi: null };
        this.saveCriteria = this.saveCriteria.bind(this);
        this.saveNewRow = this.saveNewRow.bind(this);
        this.delete = this.delete.bind(this);
        this.onCriteriaSelect = this.onCriteriaSelect.bind(this);
        this.onSelectCriteriaChange = this.onSelectCriteriaChange.bind(this);
        this.onSelectKpiChange = this.onSelectKpiChange.bind(this);
        this.initNewRow = this.initNewRow.bind(this);
        this.getKpis = this.getKpis.bind(this);
        this.showWarning = this.showWarning.bind(this);
    }


    componentDidMount() {
        this.setState({
            criterias: JSON.parse(this.props.criterias),
            hierarchykpis: JSON.parse(this.props.hierarchykpis),
        });
    }

    saveCriteria() {
        let criterias = [...this.state.criterias];
        if (this.newCriteria)
            criterias.push(this.state.newRow);
        else
            criterias[this.findSelectedCriteriaIndex()] = this.state.newRow;

        this.setState({ criterias: criterias, selectedcriteria: null, newRow: null, displayDialog: false });
        this.showWarning();
    }

    saveNewRow() {
        this.newCriteria = true;
        let criterias = [...this.state.criterias];
        var newRow = this.state.newRow;

        var foundRow = false;
        for (var idx in criterias) {
            if (((criterias[idx].criterion_id === newRow.criterion_id) || (criterias[idx].criterion_id === this.state.currentCriteria.criterion_id)) && ((criterias[idx].kpi_id === newRow.kpi_id) || (criterias[idx].kpi_id === this.state.currentKpi.kpi_id))) {
                foundRow = true;
                break;
            }
        }

        if (this.newCriteria) {
            if (!foundRow) {
                criterias.push(this.state.newRow);
            }
        }
        else
            criterias[this.findSelectedCriteriaIndex()] = this.state.newRow;

        this.setState({ criterias: criterias, selectedcriteria: null, newRow: null, currentCriteria: null, currentKpi: null });
        this.showWarning();
    }

    delete() {
        let index = this.findSelectedCriteriaIndex();
        this.setState({
            criterias: this.state.criterias.filter((val, i) => i !== index),
            selectedcriteria: null,
            newRow: null,
            displayDialog: false
        });
        this.showWarning();
    }

    findSelectedCriteriaIndex() {
        return this.state.criterias.indexOf(this.state.selectedcriteria);
    }

    updateProperty(property, value) {
        let newRow = this.state.newRow;
        newRow[property] = value;
        this.setState({ newRow: newRow });
    }

    onCriteriaSelect(e) {
        this.newCriteria = false;
        this.setState({
            displayDialog: true,
            newRow: Object.assign({}, e.data)
        });
    }

    onSelectCriteriaChange(e) {
        this.setState({ newRow: JSON.parse(JSON.stringify(e.value)) });
        this.setState({ currentCriteria: JSON.parse(JSON.stringify(e.value)) });
    }

    onSelectKpiChange(e) {
        var newRow = this.state.newRow;
        newRow['kpi_id'] = e.value.kpi_id;
        newRow['kpi_description'] = e.value.description;
        newRow['qualitative'] = e.value.assessed_manually;
        newRow['is_qualitative'] = e.value.is_qualitative;

        this.setState({ currentKpi: e.value });
    }

    initNewRow(hierarchykpis) {
        var criteriasArray = [];
        for (var key in hierarchykpis) {
            criteriasArray.push({ 'criterion_description': hierarchykpis[key].description, 'criterion_id': key, 'kpi_id': '', 'kpi_description': '', 'qualitative': '', 'is_qualitative': false });
        }
        return criteriasArray;
    }

    getKpis(newRow) {
        return this.state.hierarchykpis[newRow] ? this.state.hierarchykpis[newRow]['kpis'] : '';
    }

    /**
     * Show warning message.
     */
    showWarning() {
        this.toast.show({severity: 'warn', summary: 'Warning', detail: 'Please, save structure.', sticky: true });
    }

    render() {       
        let footer = <div className="clearfix" style={{ width: '100%' }}>
            <div>
                <Toast ref={(el) => this.toast = el} position="top-right"></Toast>
                {this.state.hierarchykpis &&
                    <div className="row">
                        <div className="col-lg-5">
                            <Dropdown value={this.state.currentCriteria} options={this.initNewRow(this.state.hierarchykpis)} onChange={this.onSelectCriteriaChange} placeholder="Select criteria" optionLabel="criterion_description" />
                        </div>
                        <div className="col-lg-5">
                            {this.state.newRow && this.state.currentCriteria &&
                                <div>
                                    <Dropdown value={this.state.currentKpi} options={this.getKpis(this.state.newRow.criterion_id)} onChange={this.onSelectKpiChange} placeholder="Select kpi" optionLabel="description" />
                                </div>
                            }
                        </div>
                        <div className="col-lg-2">
                            <Button label="Add" icon="pi pi-check" onClick={this.saveNewRow} disabled={this.state.currentKpi ? false : true} />
                        </div>
                    </div>
                }
            </div>
        </div>;

        let dialogFooter = <div className="ui-dialog-buttonpane clearfix">
            <Button icon="pi pi-times" label="Delete" onClick={this.delete} />
            {this.state.newRow && <Button label="Save" icon="pi pi-check" onClick={this.saveCriteria} disabled={false} />}
        </div>;

        return (
            <div>
                <div className="content-section implementation">
                    {this.state.hierarchykpis &&
                        <DataTable value={this.state.criterias} paginator={true} rows={10} footer={footer}
                            selectionMode="single" selection={this.state.selectedcriteria} onSelectionChange={(e) => { this.setState({ selectedcriteria: e.data }); }}
                            onRowSelect={this.onCriteriaSelect}>
                            <Column field="criterion_description" header="Criterion" />
                            <Column field="kpi_description" header="KPI" />
                            {/* <Column field="qualitative" header="Qualitative" className={'qualitative-col'} body={(rowData) => rowData.qualitative.toString()} /> */}
                        </DataTable>

                    }
                    {this.state.hierarchykpis &&
                        <input name='struct_smartgrid_branch' type="hidden" value={JSON.stringify(this.state.criterias)} />
                    }

                    <Dialog visible={this.state.displayDialog} width="400px" header="Criteria details" modal={true} footer={dialogFooter} onHide={() => this.setState({ displayDialog: false })}>
                        {this.state.newRow &&
                            <div>
                                <div className="row">
                                    <div className="col-sm-4" style={{ padding: '.75em' }}><label htmlFor="criterion_description">Criterion</label></div>
                                    <div className="col-sm-8" style={{ padding: '.5em' }}>
                                        <InputText id="criterion_description" onChange={(e) => { this.updateProperty('criterion_description', e.target.value) }} value={this.state.newRow.criterion_description} disabled={true} />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-4" style={{ padding: '.75em' }}><label htmlFor="kpi_description">Kpi</label></div>
                                    <div className="col-sm-8" style={{ padding: '.5em' }}>
                                        <InputText id="kpi_description" onChange={(e) => { this.updateProperty('kpi_description', e.target.value) }} value={this.state.newRow.kpi_description} disabled={true} />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-4" style={{ padding: '.75em' }}><label htmlFor="is_qualitative">Is qualitative</label></div>
                                    <div className="col-sm-8" style={{ padding: '.5em' }}>
                                    <Checkbox id="is_qualitative" onChange={(e) => { this.updateProperty('is_qualitative', e.checked) }} checked={this.state.newRow.is_qualitative} />
                                    </div>
                                </div>

                                {/* <div className="row">
                                    <div className="col-sm-4" style={{ padding: '.75em' }}><label htmlFor="qualitative">Qualitative</label></div>
                                    <div className="col-sm-4" style={{ padding: '.5em' }}>
                                        <InputText id="qualitative" onChange={(e) => { this.updateProperty('qualitative', e.target.value) }} value={this.state.newRow.qualitative} disabled={true} />
                                    </div>
                                </div> */}
                            </div>
                        }
                    </Dialog>
                </div>

            </div>
        );
    }
}



export default PaletSmartgrid;